import * as angular from 'angular';

function httpPrefix() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };

    function link(scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
        function ensureHttpPrefix(value: string) {
            // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
            if (value && !/^(https?):\/\//i.test(value)
                && 'http://'.indexOf(value) === -1 && 'https://'.indexOf(value) === -1) {
                ctrl.$setViewValue('http://' + value);
                ctrl.$render();
                return 'http://' + value;
            }            else {
                return value;
            }
        }
        ctrl.$formatters.push(ensureHttpPrefix);
        ctrl.$parsers.splice(0, 0, ensureHttpPrefix);
    }
}

angular
    .module('app.common')
    .directive('httpPrefix', httpPrefix);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/http-prefix.directive.ts